import { render } from "./MainPage.vue?vue&type=template&id=74cc32dc&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=74cc32dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cc32dc"]])

export default __exports__